const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].patientssn[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_4[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_4[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_4[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_4[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_4[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_4[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_4[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].GRANDMALEPILEPSY[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].PETITMALEPILEPSY[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis2[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].JACKSONIAN[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis3[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].FOCALMOTOR[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis4[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].FOCALSENSORY[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis5[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].DIENCEPHALICEPILEPSY[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis6[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].PSYCHOMOTOREPILEPSY[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis7[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].diagnosis1[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis8[1]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].diagnosis2[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis8[0]",
        },     
    ]

}

export default ssn ;